import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Checkbox from '@repo/ui/checkbox'
import InnerBox from '@repo/ui/inner-box'
import Input from '@repo/ui/input'
import Typography from '@repo/ui/typography'
import { useEffect, useState } from 'react'

import { TripTypeEnum } from '../../../../lib/types/enums/trip/trip-type.enum'
import { CenterToJourneyInput } from '../../../../lib/types/models/center-to-journey/center-to-journey-input'
import { TripProperties } from '../../../../lib/types/models/trip/properties.trip'
import { TripLight } from '../../../../lib/types/models/trip/trip'
import JourneyCardHeader from './journey-card-header'

type Props = {
  centerToJourney: CenterToJourneyInput
  onCenterToJourneyChange: (centerToJourney: CenterToJourneyInput) => void
}

const CenterJourneyCard = ({ centerToJourney, onCenterToJourneyChange }: Props) => {
  const [maxNumberOfStudentPlaces, setMaxNumberOfStudentPlaces] = useState(
    centerToJourney.maxNumberOfStudentPlaces
  )

  const mainTrips = centerToJourney.journey.places
    .map((place) => place.mainTrip)
    .filter((trip) => trip.type === TripTypeEnum.PRIMARY && !trip.linkedToMainTripId)

  const uniqueMainTrips = mainTrips.filter(
    (trip, index, self) => self.findIndex((t) => t.id === trip.id) === index
  )

  const handleCheckboxChange = (trip: TripLight) => {
    const relatedTrips = centerToJourney.relatedTrips
    const existingTrip = relatedTrips.find((relatedTrip) => relatedTrip.id === trip.id)
    const newRelatedTrips = existingTrip
      ? relatedTrips.filter((relatedTrip) => relatedTrip.id !== trip.id)
      : [...relatedTrips, trip]

    onCenterToJourneyChange({
      ...centerToJourney,
      relatedTrips: newRelatedTrips
    })
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      onCenterToJourneyChange({ ...centerToJourney, maxNumberOfStudentPlaces })
    }, 500)

    return () => clearTimeout(timer)
  }, [maxNumberOfStudentPlaces])

  return (
    <InnerBox className="p-4 rounded-lg flex flex-col gap-4">
      <JourneyCardHeader centerToJourney={centerToJourney} mode="fill" />
      <Input
        label="Nombre max de jeunes"
        required
        type="number"
        value={maxNumberOfStudentPlaces}
        onChange={(e) => {
          if (e.target.value === '') return setMaxNumberOfStudentPlaces(0)
          setMaxNumberOfStudentPlaces(parseInt(e.target.value))
        }}
      />
      <Typography variant="tag" color={tailwindColors.grey.DEFAULT}>
        Choisir les voyages principaux * :
      </Typography>
      {uniqueMainTrips.map((trip) => (
        <Checkbox
          key={trip.id}
          label={TripProperties.getTripLabel(trip)}
          checked={centerToJourney.relatedTrips.some((relatedTrip) => relatedTrip.id === trip.id)}
          onChange={() => handleCheckboxChange(trip)}
        />
      ))}
    </InnerBox>
  )
}

export default CenterJourneyCard
